export const normalizeAccountKey = (value: string | null | undefined): string => (
  (value || '').trim().toLowerCase()
);

export const hasMatchingAccount = (value: string | null | undefined, accounts: readonly string[]): boolean => {
  const normalizedValue = normalizeAccountKey(value);
  if (!normalizedValue) {
    return false;
  }
  return accounts.some((account) => normalizeAccountKey(account) === normalizedValue);
};

export const resolveCanonicalAccount = (
  selected: string | null | undefined,
  availableAccounts: readonly string[],
  fallbackToFirst: boolean = false
): string => {
  const rawSelected = (selected || '').trim();
  if (availableAccounts.length === 0) {
    return '';
  }

  if (rawSelected) {
    const exact = availableAccounts.find((account) => account === rawSelected);
    if (exact) {
      return exact;
    }

    const normalized = normalizeAccountKey(rawSelected);
    const normalizedMatch = availableAccounts.find((account) => normalizeAccountKey(account) === normalized);
    if (normalizedMatch) {
      return normalizedMatch;
    }
  }

  return fallbackToFirst ? availableAccounts[0] : rawSelected;
};

export const formatAccountDisplayLabel = (account: string, clientName?: string | null): string => {
  const normalizedClientName = (clientName || '').trim();
  const normalizedAccount = (account || '').trim();
  if (!normalizedClientName || normalizeAccountKey(normalizedClientName) === normalizeAccountKey(normalizedAccount)) {
    return normalizedAccount;
  }
  return `${normalizedClientName} (${normalizedAccount})`;
};
